module.exports = __webpack_public_path__ + "img/user-nav-jrtc-icon.9d827aa4.png";